module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                      ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                      ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                      ")])]
      }
    }])
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_5"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                      ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_6"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "styleClass": "vgt-table condensed"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-sm",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])]) : _c('span', [_vm._v("\r\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                      ")])]
      }
    }])
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_vm._v("\r\n          List of all LEDGER GROUPS\r\n        ")])])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("LEDGER GROUPS List")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#modal-xl"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "",
      "data-original-title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header d-flex p-0"
  }, [_c('h3', {
    staticClass: "card-title p-3"
  }, [_vm._v("LEDGER GROUPS LIST")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills ml-auto p-2"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab"
    }
  }, [_vm._v("ALL")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab"
    }
  }, [_vm._v("ASSETS")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab"
    }
  }, [_vm._v("LIABILITIES")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab_4",
      "data-toggle": "tab"
    }
  }, [_vm._v("EQUITY")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab_5",
      "data-toggle": "tab"
    }
  }, [_vm._v("EXPENSES")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#tab_6",
      "data-toggle": "tab"
    }
  }, [_vm._v("REVENUE")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_4"
    }
  }, [_c('p', [_vm._v("testing data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modal-xl"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("ADD LEDGER GROUP - Shareholder Fund")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Group Type "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "required": ""
    }
  }, [_c('option', [_vm._v("ASSET")]), _vm._v(" "), _c('option', [_vm._v("LIABILITY")]), _vm._v(" "), _c('option', [_vm._v("EQUITY")]), _vm._v(" "), _c('option', [_vm._v("EXPENSE")]), _vm._v(" "), _c('option', [_vm._v("REVENUE")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("System Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "System Name",
      "required": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Display Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Group Display Name",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Weightage/ Position")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter Weightage/ Position"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("SAVE GROUP")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CANCEL\r\n              ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52c738b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/LedgerGroups.vue
// module id = 808
// module chunks = 0